import isInitAppDebugEnabled from './initAppDebugCondition'
import { INIT_APP_DEBUG_EVENT, type InitAppDebugDetail } from './initAppDebugEvents'

const OVERLAY_CSS = `
#init-app-debug-overlay {
  opacity: ${process.env.NODE_ENV == 'development' ? '.8' : '.3'};
  position: fixed;
  bottom: 0px;
  left: 0px;
  z-index: 9999999;
  width: 100vw;
  max-height: 200px;
  overflow-y: auto;
  background: #d7dde0;
  color: ${process.env.NODE_ENV == 'development' ? '#0f0' : '#e0e0e0'};
  font-family: monospace;
  font-size: 8px;
  line-height: 1.1;
  padding: 2px 2px;
  border-radius: 0px;
  pointer-events: none;
  user-select: none;
  white-space: pre;
}
#init-app-debug-overlay .ok  { color: #303030; }
#init-app-debug-overlay .err { color: #f28b82; }
`

export const startInitAppDebugOverlay = (): void => {
  if (typeof window === 'undefined') return
  if (!isInitAppDebugEnabled()) return

  const buffer: InitAppDebugDetail[] = []
  let overlay: HTMLElement | null = null
  let lastOkLine: HTMLElement | null = null

  const appendLine = ({ step, status, timestamp, detail }: InitAppDebugDetail) => {
    const ts = timestamp.toFixed(0).padStart(7, ' ')
    const suffix = detail ? `  ${detail}` : ''
    const text = `[${ts}ms] ${status === 'ok' ? '✓' : '✗'} ${step}${suffix}`
    if (status === 'ok') {
      if (lastOkLine) {
        lastOkLine.style.display = 'none'
      }
      lastOkLine = document.createElement('div')
      lastOkLine.className = 'ok'
      lastOkLine.textContent = text
      overlay.appendChild(lastOkLine)
    } else {
      const line = document.createElement('div')
      line.className = 'err'
      line.textContent = text
      overlay.appendChild(line)
      overlay.scrollTop = overlay.scrollHeight
    }
  }

  window.addEventListener(INIT_APP_DEBUG_EVENT, ((e: CustomEvent<InitAppDebugDetail>) => {
    if (overlay) {
      appendLine(e.detail)
    } else {
      buffer.push(e.detail)
    }
  }) as EventListener)

  const doInitDOM = () => {
    const style = document.createElement('style')
    style.textContent = OVERLAY_CSS
    document.head.appendChild(style)

    overlay = document.createElement('div')
    overlay.id = 'init-app-debug-overlay'
    overlay.setAttribute('aria-hidden', 'true')
    
    document.body.appendChild(overlay)

    buffer.splice(0).forEach(appendLine)

    const timer = { id: undefined as ReturnType<typeof setTimeout> | undefined }
    const hideOverlay = () => {
      clearTimeout(timer.id)
      if(overlay?.style) overlay.style.display = 'none'
      window.removeEventListener('scroll', hideOverlay, { capture: true })
    }
    window.addEventListener('scroll', hideOverlay, { capture: true, once: true })
    timer.id = setTimeout(hideOverlay, 60_000)
  }

  if (document.body) {
    doInitDOM()
  } else {
    document.addEventListener('DOMContentLoaded', doInitDOM)
  }
}
